import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiSun, FiMoon, FiHome, FiShoppingBag, FiLayers, FiUser, FiBookOpen, FiArchive, FiClock, FiList, FiGift, FiShield } from 'react-icons/fi';

const Header = ({ theme, toggleTheme, currentPage }) => {
  const config = {
    dashboard: { label: 'Dashboard', icon: FiHome },
    products: { label: 'Products', icon: FiShoppingBag },
    'based-items': { label: 'Based Product Items', icon: FiLayers },
    'custom-items': { label: 'Packages', icon: FiGift },
    'stock-management': { label: 'Stock Management', icon: FiArchive },
    'product-fields': { label: 'Product Fields', icon: FiList },
    history: { label: 'History', icon: FiClock },
    guide: { label: 'Guide', icon: FiBookOpen },
    'admin-tools': { label: 'Admin Tool', icon: FiShield },
    account: { label: 'Account', icon: FiUser }
  };

  const active = config[currentPage] || config.dashboard;
  const Icon = active.icon;

  return (
    <header className="sticky top-0 z-20 w-full bg-white/50 backdrop-blur-lg dark:bg-gray-900/50 border-b border-gray-200 dark:border-gray-800">
      <div className="flex items-center justify-between px-6 py-3">
        
        {/* Title Group */}
        <div className="flex items-center gap-3">
          <motion.div
            initial={{ opacity: 0, rotate: -90 }}
            animate={{ opacity: 1, rotate: 0 }}
            className="text-gray-900 dark:text-white"
          >
            <Icon className="w-5 h-5" />
          </motion.div>
          
          <AnimatePresence mode="wait">
            <motion.h1
              key={currentPage}
              initial={{ opacity: 0, y: 5 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -5 }}
              className="text-sm font-bold tracking-tight text-gray-900 dark:text-white"
            >
              {active.label}
            </motion.h1>
          </AnimatePresence>
        </div>

        {/* Theme Toggle with refined animation */}
        <motion.button
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          onClick={toggleTheme}
          className="p-2 rounded-full hover:bg-gray-200/50 dark:hover:bg-gray-800 transition-colors"
        >
          {theme === 'light' ? (
            <FiMoon className="w-5 h-5 text-gray-600" />
          ) : (
            <FiSun className="w-5 h-5 text-yellow-500" />
          )}
        </motion.button>
      </div>

      {/* Sliding Active Indicator Line */}
      <motion.div 
        className="h-0.5 bg-gradient-to-r from-blue-500 to-purple-500"
        initial={{ width: 0 }}
        animate={{ width: "100%" }}
        transition={{ duration: 0.8, ease: "easeInOut" }}
      />
    </header>
  );
};

export default Header;
